import { LibellePartie1, LibellePartie2, TiersSortableCols } from '@core-lib/enums';
import { ITiers, ITiersList, ITiersPersonneMoraleForm, ITiersPersonnePhysiqueForm, ITiersWithAdress } from '@core-lib/models';
import { createAction, props } from '@ngrx/store';
import { createActionWithSingleProps, createTypedAction } from '../action-creators.function';
import { CorrelationParams, newAggregationId } from '../correlated-actions.model';
import { DatagridActionType, createDatagridActions } from '../datagrid-slice.function';
import { EntityActionType, createEntityActions } from '../entity-slice.function';
const ActionPrefix = 'Tiers';

export const TiersFormActions = {
	...createEntityActions<ITiersPersonnePhysiqueForm | ITiersPersonneMoraleForm>(ActionPrefix, 'Tiers confirm form'),
	LoadEntityRequest: createTypedAction(
		EntityActionType.LoadEntityRequest,
		`[${ActionPrefix}] Load tiers form`,
		(
			controlId?: string,
			structureId?: string,
			labelNature?: string,
			isFromOperationManagerModal?: boolean,
			tier?: ITiersWithAdress,
			isToUpdate?: boolean,
			isImmediateSave?: boolean,
			affairePartiesIds?:string[],
			affairePartiesTempIds?:string[],
			correlationParams: CorrelationParams = {
				correlationId: newAggregationId()
			}
		) => ({
			controlId,
			structureId,
			labelNature,
			isFromOperationManagerModal,
			tier,
			isToUpdate,
			isImmediateSave,
			affairePartiesIds,
			affairePartiesTempIds,
			correlationParams
		})
	),
	UpdateEntityRequest: createTypedAction(
		EntityActionType.UpdateEntityRequest,
		`[${ActionPrefix}] Update tiers form`,
		(
			entity: ITiersPersonnePhysiqueForm | ITiersPersonneMoraleForm,
			controlId?: string,
			structureId?: string,
			labelNature?: string,
			modalId?: string | number,
			isFromOperationManagerModal?: boolean,
			correlationParams: CorrelationParams = {
				correlationId: newAggregationId()
			}
		) => ({
			entity,
			controlId,
			structureId,
			labelNature,
			modalId,
			isFromOperationManagerModal,
			correlationParams
		})
	),
	CloseEntityModal: createTypedAction(
		EntityActionType.CloseEntityModal,
		`[${ActionPrefix}] Close tiers form modal`,
		(modalId?: string | number, isFromOperationManagerModal?: boolean) => ({
			modalId,
			isFromOperationManagerModal
		})
	)
};

export const {
	LoadEntityRequest: OpenTiersForm,
	UpdateEntityRequest: UpdateTiersRequest,
	UpdateEntitySuccess: UpdateTiersSuccess,
	UpdateEntityFailure: UpdateTiersFailure,
	SetEntityModal: SetTiersFormModal,
	CloseEntityModal: CloseTiersFormModal
} = TiersFormActions;

export const OpenTiersListModal = createAction(
	`[${ActionPrefix}] Open Tiers list Modal`,
	(
		list: ITiersList,
		entity?: ITiersPersonnePhysiqueForm | ITiersPersonneMoraleForm,
		controlId?: string,
		structureId?: string,
		modalId?: string | number,
		isFromOperationManagerModal?: boolean,
		affairePartiesIds?:string[],
		affairePartiesTempIds?:string[],
		correlationParams?: CorrelationParams
	) => ({
		list,
		entity,
		controlId,
		structureId,
		modalId,
		isFromOperationManagerModal,
		affairePartiesIds,
		affairePartiesTempIds,
		correlationParams
	})
);

export const SetTiersListModal = createActionWithSingleProps<number>(`[${ActionPrefix}] Set modal`);

export const SetDisableSubmitButton = createActionWithSingleProps<boolean>(`[${ActionPrefix}] Set Disable submit button`);

export const OpenTiersPartieDetailActions = createAction(
	`[${ActionPrefix}] Open Tiers Partie List Detail`,
	props<{ parties: ITiers[]; libelle: LibellePartie1 | LibellePartie2; affaireId?: string; structureId?: string; fromFO?: boolean; isCompteBancaireClos?:boolean }>()
);

export const TiersListActions = {
	...createDatagridActions<ITiersList, TiersSortableCols>(ActionPrefix, 'Tiers list'),
	LoadDatagridRequest: createTypedAction(
		DatagridActionType.LoadDatagridRequest,
		`[${ActionPrefix}] Load Tiers list Request`,
		(
			entity?: ITiersPersonnePhysiqueForm | ITiersPersonneMoraleForm,
			controlId?: string,
			structureId?: string,
			modalId?: string | number,
			isFromOperationManagerModal?: boolean,
			isImmediateSave?: boolean,
			affairePartiesIds?:string[],
			affairePartiesTempIds?:string[],
			correlationParams: CorrelationParams = {
				correlationId: newAggregationId()
			}
		) => ({ entity, controlId, structureId, modalId, isFromOperationManagerModal, isImmediateSave, affairePartiesIds,
			affairePartiesTempIds, correlationParams })
	)
};

export const {
	LoadDatagridRequest: LoadTiersListRequest,
	LoadDatagridSuccess: LoadTiersListSuccess,
	LoadDatagridFailure: LoadTiersListFailure
} = TiersListActions;
